

import React,{useEffect,useState, useRef} from 'react';
import Axios from "/plugins/axios";
import Head from 'next/head';
// import TagManager from 'react-gtm-module';
import GalleryCarousel from '/components/galleryCarousel';
import EventGalleryOrVideos from '/components/Brand/EventDetail/EventGalleryOrVideos';

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }
 const GalleryWidget = (props) => {
    const [data, setData] = useState([]);
    const [load, setLoad] = useState(false);
    const [error, setError] = useState('');
    const [clicked, setClicked] = useState(0);
    const [height, setHeight] = useState(0);
    const targetOrigin = process.env.IS_LOCALHOST ? 'http://localhost' + (process.env.PORT ? ':'+process.env.PORT : '') : process.env.BACKEND_URL;
  
    const active = (index, items) => {
        window.parent.postMessage({clickedIndex: index, data: items, clicked: 'clicked'}, `${targetOrigin}`)
    }
       
    useEffect(() => {
        Axios.get(`/galleries/${props.url.query.id}`)
            .then(res => {
                setData(res.data.data);
                setLoad(true);
                window.parent.postMessage(res.data.data.images && res.data.data.images.length !== 0 ? 'isContent' : 'noContent', `${targetOrigin}`)
                // TagManager.dataLayer(tagManagerArgs)
            })
            .catch(err => {
                window.parent.postMessage('noContent', `${targetOrigin}`)
                setError(err.message);
                setLoad(true)
            })
    }, []);

    if (load) {
        return (
            error ? 
                <h3 style={{ textAlign: 'center' }}>{error}</h3> 
            :
            data.images && data.images.length !== 0 ?
                <React.Fragment>
                <Head>
                    <link rel="stylesheet" type="text/css" charSet="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
                    <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
                </Head>
                {
                    props.url.query.type === 'multipleSlide' ? 
                    <>
                        <EventGalleryOrVideos items={data.images} active={active} />
                        </>
                        :
                        <GalleryCarousel items={data.images} active={active} />
                        
                }
                </React.Fragment>
            : <h3 style={{ textAlign: 'center' }}>There is no image of gallery.</h3>
        );
    } else {
        return (
            <div>   
                Loading gallery widget...          
                <div className="placeholderbox">
                  <div className="banner-holder"></div>
                  <hr className="hr-box" />            
                  <span className="title-holder text-group"></span>
                  <div className="text-group p-holder"></div>
                  <div className="text-group"></div>
                </div> 
            </div>
        );
    }
};
export default GalleryWidget;